import React from 'react';
import classnames from 'classnames';

import { useShortSelector } from 'react-redux-app/lib/modules/core/hooks';

import { getIndexUrl } from '../../utils/siteUrls';

import {
  SITE_ID__RIVCASH,
  SITE_ID__IXCASH,
  SITE_ID__ONLYFEETCASH,
} from '../../constants/rivcashClones';

import { getIsActive } from '../../../auth/selectors';
import { getRivcashCloneId } from '../../../init/selectors/initData';

import LangLink from '../../../core/i18n/components/LangLink';

import styles from './styles/index.css.json';


const logoStyleMap = {
  [SITE_ID__RIVCASH]: styles.logo_RIVcash,
  [SITE_ID__IXCASH]: styles.logo_IXcash,
  [SITE_ID__ONLYFEETCASH]: styles.logo_onlyfeetcash,
};

export default () => {
  const siteId = useShortSelector(getRivcashCloneId);
  const isUserActive = useShortSelector(getIsActive);

  return (
    isUserActive
      ? <LangLink className={classnames(styles.logo, logoStyleMap[siteId])} to={getIndexUrl()} />
      : <div className={classnames(styles.logo, logoStyleMap[siteId])} />
  );
};
